import { getFirstLinkedAssetOrDefault } from '@r-and-a-shared-ui/common-kontent-client/utils';

import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export const file_embed = (entry: PLAYER_PORTALS_MODELS.FileEmbed) => {
  if (!entry || !entry?.elements) {
    return undefined;
  }

  const { elements } = entry;

  return {
    resource: getFirstLinkedAssetOrDefault(elements?.resource),
  };
};

export default file_embed;
